import { useEffect } from 'react'

/**
 * Hook per impostare il titolo della pagina
 * @param title - Il titolo da impostare
 * @param suffix - Suffisso opzionale (default: "PWS Mondo Welfare")
 */
export function usePageTitle(title?: string, suffix: string = 'PWS Mondo Welfare') {
  useEffect(() => {
    if (title) {
      document.title = `${title} - ${suffix}`
    } else {
      document.title = suffix
    }

    // Cleanup: ripristina il titolo di default quando il componente viene smontato
    return () => {
      document.title = suffix
    }
  }, [title, suffix])
}
